import request from "./../utils/request";

export function getMailList({ incoming, outgoing, refVisitorId, mailAddress, skip, limit, searchValue }) {
    return request({
        url: `/mail/my`,
        method: "get",
        params: {
            incoming,
            outgoing,
            refVisitorId,
            mailAddress,
            skip,
            limit,
            searchValue,
        },
    }).then((res) => res.data);
}

export function getDepartmentEmailList({ userId, mailAddress, skip, limit, searchValue }) {
    return request({
        url: `/mail/my`,
        method: "get",
        params: {
            incoming: true,
            outgoing: true,
            userId,
            mailAddress,
            skip,
            limit,
            searchValue,
        },
    }).then((res) => res.data);
}

export function getVisitorMailList(payload) {
    return request({
        url: `/mail/visitor`,
        method: "get",
        params: {
            ...payload,
        },
    });
}

export function getUserMailList(userId, mailAddressId, pageCount, perPage, searchValue) {
    return request({
        url: `/mail/user`,
        method: "get",
        params: {
            userId,
            mailAddressId,
            pageCount,
            perPage,
            searchValue,
        },
    }).then((res) => res.data);
}

export function getMailDetails(threadId) {
    return request({
        url: `/mail/detail/${threadId}`,
        method: "get",
    });
}

export function cleanUnreadThread(userId, threadId) {
    return request({
        url: `/mail/clean-unread-thread/${userId}/${threadId}`,
        method: "get",
    });
}

export function cleanAllUnreadThread(userId) {
    return request({
        url: `/mail/clean-all-unread-thread/${userId}`,
        method: "get",
    });
}

export function getSearchValueMails(userId, pageCount, perPage, inputValue) {
    return request({
        url: `/mail/search-value-mails`,
        method: "get",
        params: {
            userId,
            inputValue,
            pageCount,
            perPage,
        },
    });
}

export function getUserEmail(userId) {
    return request({
        url: `/mail/userMailAddress/${userId}`,
        method: "get",
    });
}

export function getMailAddressByToList(data) {
    return request({
        url: `/mail/mails-by-to-list`,
        method: "post",
        data,
    });
}

export function createVisitorAndMailAddressMulti(data) {
    return request({
        url: `/mail/visitor-mail-address-multi`,
        method: "post",
        data,
    });
}

export function getMailAddressesByInputValue(userId, inputValue, selectedMailAddress) {
    return request({
        url: `/mail/get-mail-addresses-by-input-value`,
        method: "get",
        params: {
            userId,
            inputValue,
            selectedMailAddress,
        },
    });
}

export function getSenderMailAddressesByInput(userId, inputValue) {
    return request({
        url: `/mail/get-sender-mail-addresses-by-input/${userId}/${inputValue}`,
        method: "get",
    });
}

export function getDepartmentMailAndCount(userId) {
    return request({
        url: `/mail/department-mail-and-count/${userId}`,
        method: "get",
    });
}

export function getDepartmentMailAddresses(userId) {
    return request({
        url: `/mail/department-mail-addresses/${userId}`,
        method: "get",
    });
}

export function getAllUnreadMailCount(userId) {
    return request({
        url: `/mail/all-unread-mail-count/${userId}`,
        method: "get",
    });
}

export function deleteThreadMessage(threadId, mailId) {
    return request({
        url: `/mail/${threadId}/${mailId}`,
        method: "delete",
    }).then((res) => res.data);
}

export function deleteThread(threadId) {
    return request({
        url: `/mail/${threadId}`,
        method: "delete",
    });
}

export function mailVerification(userId, departmentId, mail) {
    return request({
        url: `/mail/mail-verification/${userId}/${departmentId}/${mail}`,
        method: "get",
    });
}

export function getVisitorsByMailAddress(mailList) {
    return request({
        url: `/visitors/by-mail-address`,
        method: "post",
        data: mailList,
    });
}

export function createMailTemplate(payload) {
    return request({
        url: `/mail/templates`,
        method: "put",
        data: payload,
    }).then((res) => res.data);
}

export function deleteMailTemplate(templateId) {
    return request({
        url: `/mail/templates/${templateId}`,
        method: "delete",
    }).then((res) => res.data);
}

export function updateEmailTemplate(templateId, updatingFields) {
    return request({
        url: `/mail/templates/${templateId}`,
        method: "post",
        data: {
            updatingFields,
        },
    }).then((res) => res.data);
}

export function listEmailTemplates(filters, cursor) {
    let data = {};
    if (filters) data.filters = filters;
    if (cursor) data.cursor = cursor;
    return request({
        url: `/mail/templates`,
        method: "post",
        data: { filters, cursor },
    }).then((res) => res.data);
}

export function getUserMediaList(mailAddressId, skip, limit) {
    return request({
        url: `/mail/user-all-medias`,
        method: "get",
        params: {
            mailAddressId,
            skip,
            limit,
        },
    });
}

export function getDepartmentMediaList(departmentName, pageCount, perPage) {
    return request({
        url: `/mail/department-all-medias`,
        method: "get",
        params: {
            departmentName,
            skip,
            limit,
        },
    });
}

export function saveSignature(mailAddress, html) {
    return request({
        url: `/mail/save-signature`,
        method: "post",
        data: {
            mailAddress,
            html,
        },
    });
}

export function getMailSignature(mailAddress) {
    return request({
        url: `/mail/get-signature`,
        method: "get",
        params: {
            mailAddress,
        },
    });
}

export function changeSignatureAutoUse(mailAddress, isAutoAdd) {
    return request({
        url: `/mail/signature-auto-add`,
        method: "put",
        data: {
            mailAddress,
            isAutoAdd,
        },
    });
}

export function changeVisibility(id, mail, visibility) {
    return request({
        url: `/mail/change-visibility/${id}`,
        method: "post",
        data: {
            mail,
            visibility,
        },
    });
}

//ilgili kullanıcı için detay sayfasında görünürlüğü aktif olanları getirir
export function getVisibilityUser(id) {
    return request({
        url: `/mail/user-visibility/${id}`,
        method: "get",
    });
}

// mail sayfasında görebileceği mail adreslerini getirir
export function getVisibilityMailAddress(id) {
    return request({
        url: `/mail/visibility-mail-address/${id}`,
        method: "get",
    });
}

export function createMailAddress(data) {
    return request({
        url: `/mail/mail-address`,
        method: "post",
        data: { data },
    });
}

export function getMailVisitors(data) {
    return request({
        url: `/mail/mail-visitors`,
        method: "get",
        params: data,
    });
}

export function getSenderMailAddress(data) {
    return request({
        url: `/mail/sender-mail-address`,
        method: "get",
        params: data,
    });
}

export function changeDefaultMailAddress(payload) {
    return request({
        url: `/mail/change-default-mail`,
        method: "put",
        data: payload,
    });
}

export function deleteSenderMail(mailAddressId) {
    return request({
        url: `/mail/delete-sender-mail/${mailAddressId}`,
        method: "delete",
    });
}

export function changeIsAgentMailVisible(userId, visible) {
    return request({
        url: `/mail/change-agent-mail-visible/${userId}`,
        data: { visible },
        method: "put",
    });
}

export function getAgentMailVisibility(userId) {
    return request.get(`/users/get-agent-mail-visibility/${userId}`);
}

/**
 * return all agent email address list
 */
function getAgentsEmailAddressList() {
    return request.get(`/mail/all-agent-email-address-list`).then((res) => res.data);
}

function searchEmailAddress() {
    return request.get(`/mail/search-email-address`).then((res) => res.data);
}

function createForwardEmailAddress(data) {
    return request.put(`/mail/mail-address/create-forward-email`, { data }).then((res) => res.data);
}

function getEmailTemplateById(templateId) {
    return request.get(`/mail/templates/${templateId}`).then((res) => res.data);
}

export const MAIL_API = {
    createForwardEmailAddress,
    getAgentsEmailAddressList,
    searchEmailAddress,
    deleteMultiThreads: (threadIds) => {
        return request({
            url: `/mail/delete-multi-threads`,
            method: "post",
            data: { threadIds },
        }).then((res) => res.data);
    },
    markReadMulti: (threadIds) => {
        return request({
            url: `/mail/mark-read-multi`,
            method: "post",
            data: { threadIds },
        }).then((res) => res.data);
    },
    getUnReplyMails({ refVisitorId, mailAddress, skip, limit, searchValue }) {
        return request({
            url: `/mail/unreply`,
            method: "get",
            params: {
                refVisitorId,
                mailAddress,
                skip,
                limit,
                searchValue,
            },
        }).then((res) => res.data);
    },
    getUnreadMails(payload) {
        return request({
            url: `/mail/unread-mails`,
            method: "get",
            params: {
                ...payload,
            },
        }).then((res) => res.data);
    },
    getMailList,
    getVisitorMailList,
    getUserMailList,
    getMailDetails,
    cleanUnreadThread,
    cleanAllUnreadThread,
    getSearchValueMails,
    getUserEmail,
    getMailAddressByToList,
    createVisitorAndMailAddressMulti,
    getMailAddressesByInputValue,
    getSenderMailAddressesByInput,
    getDepartmentMailAndCount,
    getDepartmentMailAddresses,
    getAllUnreadMailCount,
    deleteThreadMessage,
    deleteThread,
    mailVerification,
    getVisitorsByMailAddress,
    createMailTemplate,
    getUserMediaList,
    getDepartmentMediaList,
    saveSignature,
    getMailSignature,
    changeSignatureAutoUse,
    changeVisibility,
    getVisibilityUser,
    getVisibilityMailAddress,
    createMailAddress,
    getMailVisitors,
    getSenderMailAddress,
    changeDefaultMailAddress,
    deleteSenderMail,
    changeIsAgentMailVisible,
    getAgentMailVisibility,
    TEMPLATE: {
        createMailTemplate,
        listEmailTemplates,
        updateEmailTemplate,
        getEmailTemplateById,
        deleteMailTemplate,
    },
    BROADCAST: {
        create: (body) => request.post(`/mail/broadcasts`, body).then((res) => res.data),
        list: (page, perPage, archived) => request.get(`/mail/broadcasts`, { params: { page, perPage, archived } }),
        archive: (broadcastId) => request.put(`/mail/broadcasts/${broadcastId}/archive`),
        saveAsEmailCustomerGroup: (siteId, filters, query, groupName) =>
            request.post(`/mail/customer-groups/save`, { siteId, filters, query, groupName }),
        deleteEmailCustomerGroup: (groupId) => request.delete(`/mail/customer-groups/${groupId}`),
        getCustomerGroups: () => request.get(`/mail/customer-groups`),
        getCustomerGroupContacts: (groupId, page, perPage) =>
            request.get(`/mail/customer-groups/${groupId}/contacts`, {
                params: {
                    page,
                    perPage,
                },
            }),
        getEmailBroadcastSentDetails: (broadcastId, page, perPage) => {
            return request.get(`/mail/broadcasts/${broadcastId}/details`, {
                params: {
                    page,
                    perPage,
                },
            });
        },
        getEmailBroadcastMonthDetail: (isBroadcast) => {
            return request.get(`/mail/broadcasts/month-detail` + (isBroadcast ? "?isBroadcast=true" : ""));
        },
    },
};
